<template>
  <div class="playing-card" :class="[sizeClass, { 'is-revealed': revealed, 'is-red': isRed }]">
    <div class="card-inner">
      <div class="card-front">
        <template v-if="revealed">
          <div class="card-corner top-left">
            <span class="value">{{ card.value }}</span>
            <span class="suit-icon" v-html="suitIcon"></span>
          </div>
          <div class="card-center">
            <span class="suit-icon large" v-html="suitIcon"></span>
          </div>
          <div class="card-corner bottom-right">
            <span class="value">{{ card.value }}</span>
            <span class="suit-icon" v-html="suitIcon"></span>
          </div>
        </template>
      </div>
      <div class="card-back">
        <div class="back-pattern"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlayingCard',
  props: {
    card: {
      type: Object,
      required: true // { value: '7', suit: 'heart' }
    },
    revealed: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'normal' // 'normal', 'small'
    }
  },
  computed: {
    isRed() {
      return ['heart', 'diamond'].includes(this.card.suit);
    },
    suitIcon() {
      switch (this.card.suit) {
        case 'heart': return '&hearts;';
        case 'diamond': return '&diams;';
        case 'club': return '&clubs;';
        case 'spade': return '&spades;';
        default: return '';
      }
    },
    sizeClass() {
      return `size-${this.size}`;
    }
  }
}
</script>

<style scoped>
.playing-card {
  perspective: 1000px;
  width: 65px;
  height: 95px;
  user-select: none;
}
.playing-card.size-small {
  width: 50px;
  height: 75px;
}

.card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  transform-style: preserve-3d;
}

.playing-card:not(.is-revealed) .card-inner {
  transform: rotateY(180deg);
}

.card-front, .card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.15);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
}

.card-front {
  background-color: white;
  border: 1px solid #ccc;
  color: black; /* default suit color */
}

.is-red .card-front {
  color: #d32f2f; /* Red suits */
}

.card-back {
  background-color: #1976d2; /* classic blue back */
  border: 2px solid white;
  transform: rotateY(180deg);
  padding: 4px;
}

.back-pattern {
  width: 100%;
  height: 100%;
  background: 
    linear-gradient(135deg, rgba(255,255,255,0.2) 25%, transparent 25%) -20px 0,
    linear-gradient(225deg, rgba(255,255,255,0.2) 25%, transparent 25%) -20px 0,
    linear-gradient(315deg, rgba(255,255,255,0.2) 25%, transparent 25%),
    linear-gradient(45deg, rgba(255,255,255,0.2) 25%, transparent 25%);
  background-size: 15px 15px;
  background-color: #0d47a1;
  border-radius: 3px;
}

/* Card details */
.card-corner {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2px 4px;
  font-family: Arial, sans-serif;
  font-weight: bold;
}

.size-small .card-corner {
  padding: 1px 2px;
  font-size: 0.8rem;
}

.top-left {
  align-self: flex-start;
}

.bottom-right {
  align-self: flex-end;
  transform: rotate(180deg);
}

.suit-icon {
  line-height: 1;
}

.card-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.suit-icon.large {
  font-size: 2rem;
  opacity: 0.8;
}

.size-small .suit-icon.large {
  font-size: 1.5rem;
}
</style>
